import { DriveStep } from "driver.js";

/**
 * Common final steps shared across all product tours.
 * Includes:
 * 1. Highlight the "Take a Tour" button for future reference
 * 2. Support contact information
 */
export const getCommonFinalSteps = (
  t: (key: string) => string
): DriveStep[] => [
  {
    element: '[data-tour="take-tour-button"]',
    popover: {
      title: t("tour.common.takeTour.title"),
      description: t("tour.common.takeTour.description"),
      side: "bottom",
      align: "end",
    },
  },
  {
    popover: {
      title: t("tour.common.support.title"),
      description: t("tour.common.support.description"),
    },
  },
];
